import {formatPrice} from '../hooks/generalHooks';

const Card = ({title, image, productName, price, onClick }) =>{
    return(
        <div 
            className="group bg-white rounded-[36px] border border-gray-200 p-3 md:p-4 cursor-pointer transition-all duration-300 hover:shadow-xl hover:scale-105 flex flex-col items-center h-full" 
            onClick={onClick}
        >
            {/* Image Container */}
            <div className="w-full aspect-square flex items-center justify-center overflow-hidden">
                <img 
                    src={image} 
                    alt={title}
                    className="w-3/4 md:w-full h-3/4 md:h-full object-contain transition-transform duration-300 group-hover:scale-110" 
                />
            </div>
            
            {/* Product Details */}
            {productName && (
                <span className="text-xs md:text-sm text-gray-600 mb-1 font-medium text-center"> 
                    {productName} 
                </span>
            )}
            
            {price && (
                <span className="text-base md:text-lg font-semibold text-primary mb-2"> 
                    € {formatPrice(price)} 
                </span>
            )}
            
            {/* Category Title - Fixed height with line clamp */}
            <h6 className="text-sm md:text-base lg:text-lg font-semibold text-[#232B55] text-center mt-2 line-clamp-2 min-h-[2.5rem] md:min-h-[3rem]"> 
                {title} 
            </h6>
        </div>
    )
}

export default Card;